var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 128,
    viewBox: "0 0 162 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.39 45.371H17.6055V103.605C17.6052 104.958 18.0444 106.275 18.8581 107.361C19.6717 108.447 20.8164 109.243 22.1222 109.632L79.1752 126.62C80.3643 126.972 81.6312 126.972 82.8203 126.62L139.873 109.632C141.179 109.243 142.324 108.447 143.137 107.361C143.951 106.275 144.39 104.958 144.39 103.605V45.371Z",
    fill: "url(#paint0_linear_910_19621)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.388 45.371H80.9959C80.9959 45.371 80.381 126.884 80.9959 126.884C81.6109 126.884 82.2226 126.796 82.8185 126.62L139.872 109.632C141.177 109.243 142.322 108.447 143.136 107.361C143.949 106.275 144.389 104.958 144.388 103.605V45.371Z",
    fill: "url(#paint1_linear_910_19621)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9979 65.7838L17.6056 45.371L1.51978 69.0396C1.24482 69.4436 1.0682 69.9054 1.00387 70.3886C0.939537 70.8719 0.989247 71.3634 1.14908 71.8243C1.30891 72.2853 1.57449 72.703 1.92485 73.0447C2.27522 73.3863 2.70079 73.6424 3.16798 73.7929L60.2052 92.183C60.8587 92.3938 61.5636 92.3882 62.2136 92.1669C62.8636 91.9456 63.4235 91.5207 63.8091 90.9561L80.9979 65.7838Z",
    fill: "url(#paint2_linear_910_19621)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.392 45.371L81 65.7838L98.1888 90.9561C98.5743 91.5207 99.1343 91.9456 99.7843 92.1669C100.434 92.3882 101.139 92.3938 101.793 92.183L158.83 73.7929C159.297 73.6424 159.723 73.3863 160.073 73.0447C160.423 72.703 160.689 72.2853 160.849 71.8243C161.009 71.3634 161.058 70.8719 160.994 70.3886C160.93 69.9054 160.753 69.4436 160.478 69.0396L144.392 45.371Z",
    fill: "url(#paint3_linear_910_19621)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6547 2.4912C65.2685 1.92839 64.7087 1.50515 64.0594 1.28506C63.4101 1.06497 62.7064 1.05991 62.054 1.27065L5.01361 19.6639C4.54609 19.8134 4.12006 20.0688 3.76929 20.4101C3.41851 20.7513 3.15262 21.169 2.99269 21.6299C2.83276 22.0908 2.78318 22.5824 2.84787 23.0656C2.91256 23.5488 3.08975 24.0105 3.36541 24.414L17.6065 45.371L80.9988 24.889L65.6547 2.4912Z",
    fill: "url(#paint4_linear_910_19621)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.633 24.414C158.908 24.0101 159.084 23.5486 159.148 23.0657C159.212 22.5828 159.162 22.0917 159.002 21.6312C158.842 21.1707 158.577 20.7533 158.227 20.4119C157.877 20.0705 157.452 19.8145 156.985 19.6639L99.9448 1.27065C99.2924 1.05991 98.5887 1.06497 97.9394 1.28506C97.2901 1.50515 96.7303 1.92839 96.3441 2.4912L81 24.889L144.392 45.371L158.633 24.414Z",
    fill: "url(#paint5_linear_910_19621)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.39 45.371L80.9978 24.889L17.6055 45.371L80.9978 65.7838L144.39 45.371Z",
    fill: "url(#paint6_linear_910_19621)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9978 65.7838V24.889L17.6055 45.371L80.9978 65.7838Z",
    fill: "url(#paint7_linear_910_19621)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_910_19621",
    x1: 80.9978,
    y1: 24.9733,
    x2: 80.9978,
    y2: 117.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4353",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A95B9",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_910_19621",
    x1: 112.555,
    y1: 24.9733,
    x2: 112.555,
    y2: 117.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4353",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A95B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_910_19621",
    x1: 18.0271,
    y1: 45.3458,
    x2: 26.757,
    y2: 103.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_910_19621",
    x1: 81.2567,
    y1: 65.5699,
    x2: 147.832,
    y2: 104.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA3B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_910_19621",
    x1: 9.30844,
    y1: 33.1623,
    x2: 18.7339,
    y2: -11.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454B5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_910_19621",
    x1: 97.9701,
    y1: 0.512521,
    x2: 101.338,
    y2: 55.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262A38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_910_19621",
    x1: 17.6055,
    y1: 45.3364,
    x2: 144.39,
    y2: 45.3364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303442"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_910_19621",
    x1: 49.3016,
    y1: 14.6555,
    x2: 49.3016,
    y2: 61.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4353",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A95B9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.7fb10e271a864c5854e88b8ce9f484a5.svg";
export { ForwardRef as ReactComponent };